import { useEffect } from 'react';

import useTranslation from '../../hooks/useTranslation';

const setMetaContent = (selector: string, content: string): void => {
  const element = document.querySelector(selector);
  if (element) {
    element.setAttribute('content', content);
  }
};

/** Keeps document title / social meta in sync with the active UI language. */
export const DocumentMeta = () => {
  const { t, language } = useTranslation();

  useEffect(() => {
    const title = t('documentMeta.title');
    const description = t('documentMeta.description');

    document.title = title;
    setMetaContent('meta[name="description"]', description);
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[property="og:description"]', description);
    setMetaContent('meta[name="twitter:title"]', title);
    setMetaContent('meta[name="twitter:description"]', description);
    // Sync when UI language changes; `t` is stable for a given language.code.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional
  }, [language.code]);

  return null;
};

export default DocumentMeta;
